<template>
  <div class="px-ogs bg-paint pb-40">
    <div class="max-w-6xl mx-auto">
      <div class="grid grid-cols-12 gap-x-gs gap-y-8">
        <div v-for="(item, index) in items" :key="index" class="col-span-4">
          <FlexibleContentRichPartnersItem :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FlexibleContentRichPartnersItem from "./FlexibleContentRichPartnersItem.vue";

export default {
  name: "FlexibleContentRichPartners",
  components: {
    FlexibleContentRichPartnersItem,
  },
  props: {
    entry: {
      type: Number,
      default: null,
    },
    block: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      items: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      axios({
        url: "/api",
        method: "post",
        data: {
          query: `
            query accordionQuery($entry: [QueryArgument], $block: [QueryArgument]) {
              products(id: $entry) {
                ... on paint_Product {
                  flexibleContentRich(id: $block) {
                    ... on flexibleContentRich_partners_BlockType {
                      partners {
                        ... on partners_BlockType {
                          itemHeading
                          itemSubHeading
                          itemLink
                          itemImage {
                            url(width: 990)
                            title
                          }
                        }
                      }
                    }
                  }
                }
                ... on supplementary_Product {
                  flexibleContentRich(id: $block) {
                    ... on flexibleContentRich_partners_BlockType {
                      partners {
                        ... on partners_BlockType {
                          itemHeading
                          itemSubHeading
                          itemLink
                          itemImage {
                            url(width: 990)
                            title
                          }
                        }
                      }
                    }
                  }
                }
                ... on coating_Product {
                  flexibleContentRich(id: $block) {
                    ... on flexibleContentRich_partners_BlockType {
                      partners {
                        ... on partners_BlockType {
                          itemHeading
                          itemSubHeading
                          itemLink
                          itemImage {
                            url(width: 990)
                            title
                          }
                        }
                      }
                    }
                  }
                }
              }
              entries(id: $entry) {
                ... on home_home_Entry {
                  flexibleContentRich(id: $block) {
                    ... on flexibleContentRich_partners_BlockType {
                      partners {
                        ... on partners_BlockType {
                          itemHeading
                          itemSubHeading
                          itemLink
                          itemImage {
                            url(width: 990)
                            title
                          }
                        }
                      }
                    }
                  }
                }
                ... on giftVouchers_giftVouchers_Entry {
                  flexibleContentRich(id: $block) {
                    ... on flexibleContentRich_partners_BlockType {
                      partners {
                        ... on partners_BlockType {
                          itemHeading
                          itemSubHeading
                          itemLink
                          itemImage {
                            url(width: 990)
                            title
                          }
                        }
                      }
                    }
                  }
                }
                ... on pages_richFlexibleContent_Entry {
                  flexibleContentRich(id: $block) {
                    ... on flexibleContentRich_partners_BlockType {
                      partners {
                        ... on partners_BlockType {
                          itemHeading
                          itemSubHeading
                          itemLink
                          itemImage {
                            url(width: 990)
                            title
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          `,
          variables: {
            entry: this.entry,
            block: this.block,
          },
        },
      }).then((result) => {
        /* eslint-disable no-unused-vars */
        /* eslint-disable prefer-destructuring */
        let data;
        const { products } = result.data.data;
        const { entries } = result.data.data;

        if (products.length) {
          data = products[0].flexibleContentRich[0];
        }
        if (entries.length) {
          data = entries[0].flexibleContentRich[0];
        }
        this.items = data.partners;
      });
    },
  },
};
</script>
